import _ from 'lodash'
import { REGEX } from '@gymondo/frontend-core/utils'
import style from '../term-and-condition.module.scss'

export default {
    /**
     * Create a link slug for the left navigation links
     * @param {string} text - the link text
     */
    getLinkSlug(text) {
        // possible format #999-description
        return (
            text &&
            text
                .replace('. ', '-')
                .split(' ')[0]
                .toLowerCase()
                .replace(/[^\w0-9-]/g, '')
        )
    },

    /**
     * Add anchor to emails
     * @param {string} html - html content
     */
    replaceEmail(html) {
        return (
            html &&
            html.replace(
                new RegExp(`(${REGEX.email.source})`, 'ig'),
                '<a href="mailto:$1">$1</a>'
            )
        )
    },

    /**
     * Replace the parameters into the template
     * @param {string} html - html file
     * @param {object} parameters - parameters to be injected on the html file, if none, return html
     */
    replaceIntoTemplate(html, parameters) {
        if (!parameters) {
            return html
        }

        return Object.entries(parameters).reduce(
            (acc, param) =>
                acc.replace(new RegExp(`\\$${param[0]}`, 'g'), param[1]),
            html
        )
    },

    /**
     * Add an anchor before title for navigation
     * @param {string} html - html file
     * */
    addAnchorToHeaders(html) {
        return (
            html &&
            html.replace(
                /<h2>(.*)<\/h2>/g,
                (match, capture) => `<a 
                    class="${style.anchor}"
                    id="${this.getLinkSlug(capture)}">
                    </a>
                    <h2>${capture}</h2>`
            )
        )
    },

    /**
     * Merge all the files (template + parameters)
     * @param {*} data - files fetched from gatsby containing variables and parameters
     */
    treatFiles(data) {
        const edgesMarkdown = _.get(data, 'allMarkdownRemark.edges')
        const edges = _.get(data, 'allFile.edges')

        if (
            (edges && edges.length > 1) ||
            (edgesMarkdown && edgesMarkdown > 1)
        ) {
            throw new Error('NOT IMPLEMENTED')
        }

        const { html, headings } = _.get(edgesMarkdown, '0.node') || {}

        const { parameters } =
            _.get(edges, '0.node.childContentJson.terms') || {}

        let formattedHtml = this.replaceIntoTemplate(html, parameters)

        // just h2 elements (remove initial number and dots)
        const links =
            headings &&
            headings
                .map(
                    heading =>
                        heading.depth === 2 && {
                            title: heading.value.replace(/([0-9]*\.) /, ''),
                            link: this.getLinkSlug(heading.value),
                        }
                )
                .filter(heading => heading)

        // add achor to headers to work with side menu
        formattedHtml = this.addAnchorToHeaders(formattedHtml)

        // add anchor to emails
        formattedHtml = this.replaceEmail(formattedHtml)

        return { html: formattedHtml, links }
    },
}
